// Base API URL: set REACT_APP_BASE_API_URL in .env (see .env.example).
// Use trailing slash so paths stay consistent: BaseAPI + 'user/login'
const baseUrl = process.env.REACT_APP_BASE_API_URL || 'http://localhost:8989/api';
export const BaseAPI = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
// export const MediaAPI = 'https://api.himalayantrailrunning.com/'